import { useTranslation } from "react-i18next";
import { CalendarX2, ShieldAlert, type LucideIcon } from "lucide-react";
import { getOpenRequestMessage, getOpenRequestSource, hasOpenRequest } from "../helpers/eventdisplay/hasOpenRequest";
import { cn } from "../../../../lib/utils";

const sourceIcons: Record<string, { icon: LucideIcon; className: string }> = {
    "qualification-change": { icon: ShieldAlert, className: "tw-text-amber-600" },
    absence: { icon: CalendarX2, className: "tw-text-rose-600" },
};

function OpenRequestIndicator({ event, className }: { event: any; className?: string }) {
    const { t } = useTranslation();

    if (!hasOpenRequest(event)) return null;

    const sourceIcon = sourceIcons[getOpenRequestSource(event) ?? ""];

    if (sourceIcon) {
        const Icon = sourceIcon.icon;
        return (
            <span
                title={t(getOpenRequestMessage(event))}
                className={cn("tw-inline-flex tw-shrink-0", className)}
            >
                <Icon className={cn("tw-size-3", sourceIcon.className)} strokeWidth={2.5} />
            </span>
        );
    }

    return <span
        title={t("has-open-shift-request")}
        className={cn("tw-w-2 tw-h-2 tw-rounded-full tw-bg-amber-500 tw-shrink-0", className)}
    />;
}

export default OpenRequestIndicator;
